export interface ProfessionalRadioGroupProps {
  isProfessional: boolean;
  onIsProfessionalChange: (value: boolean) => void;
  /** Radio group `name` (unique per form if multiple groups). */
  name?: string;
}

export const ProfessionalRadioGroup = ({
  isProfessional,
  onIsProfessionalChange,
  name = "isProfessional",
}: ProfessionalRadioGroupProps) => (
  <div className="mb-6">
    <label className="mb-3 block text-sm font-semibold text-muted-foreground">
      Are you a professional?
      <span className="ml-1 text-destructive">*</span>
    </label>
    <div className="grid grid-cols-2 gap-4">
      <label
        className={`flex cursor-pointer items-center justify-center rounded-xl border-2 px-4 py-3 transition-all duration-200 ${
          isProfessional === true
            ? "border-primary bg-primary-subtle text-primary-emphasis shadow-sm"
            : "border-border bg-card text-muted-foreground hover:border-input"
        }`}
      >
        <input
          type="radio"
          name={name}
          checked={isProfessional === true}
          onChange={() => onIsProfessionalChange(true)}
          className="sr-only"
        />
        <span className="text-sm font-medium">Yes, I am</span>
      </label>
      <label
        className={`flex cursor-pointer items-center justify-center rounded-xl border-2 px-4 py-3 transition-all duration-200 ${
          isProfessional === false
            ? "border-primary bg-primary-subtle text-primary-emphasis shadow-sm"
            : "border-border bg-card text-muted-foreground hover:border-input"
        }`}
      >
        <input
          type="radio"
          name={name}
          checked={isProfessional === false}
          onChange={() => onIsProfessionalChange(false)}
          className="sr-only"
        />
        <span className="text-sm font-medium">No, I'm not</span>
      </label>
    </div>
  </div>
);
